import React from 'react'
import Navbarsticky from './NavbarSticky'
import Footer from './Footer'
import { Container, Row, Col, Card, Button } from 'react-bootstrap'
import deals from "../assets/img/tourgridt-img2.png";
import hotel from "../assets/img/hoteldetails-img2.png";
import car from "../assets/img/carImg-card.png";
import Carousel from "react-multi-carousel";

// serrvice provider 
import water from "../assets/img/scuba.jpg";
import ferryboat from "../assets/img/makruzz.jpg";
import hotelbook from "../assets/img/hoteldetails-img6.png";
import carrental from "../assets/img/car.jpg";

// destination img 
import destinationimg1 from "../assets/img/tour-list8.jpg";
import destinationimg2 from "../assets/img/cove.jpg";
import destinationimg3 from "../assets/img/destination8.jpg";
import destinationimg4 from "../assets/img/north-bay.jpeg";
import destinationimg5 from "../assets/img/img5.jpg";

// testimonal img
import testimonialImg from "../assets/img/reviewimg2.png";

// blog img
import blogImg1 from "../assets/img/hotel4.jpg";
import blogImg2 from "../assets/img/visiting-place6.jpg";
import blogImg3 from "../assets/img/contact1.jpg";






export default function FerryList() {


    const dealsData = [
        {
            id: 1,
            img: deals,
            title: "Beautiful Andaman",
            location: "Portblair",
            price: "18,800",
            rating: 4.5,
        },
        {
            id: 2,
            img: deals,
            title: "Beautiful Andaman",
            location: "Portblair",
            price: "18,800",
            rating: 4.5,
        },
        {
            id: 3,
            img: deals,
            title: "Beautiful Andaman",
            location: "Portblair",
            price: "18,800",
            rating: 4.5,
        },
        {
            id: 4,
            img: deals,
            title: "Beautiful Andaman",
            location: "Portblair",
            price: "18,800",
            rating: 4.5,
        },
    ];


    const hotelData = [
        {
            id: 1,
            img: hotel,
            name: "Taj Exotica",
            price: "7,000",
            place: "Havelock, Andaman",
        },
        {
            id: 2,
            img: hotel,
            name: "ITC Grand",
            price: "10,000",
            place: "Havelock, Andaman",
        },
        {
            id: 3,
            img: hotel,
            name: "Taj Exotica",
            price: "7,000",
            place: "Havelock, Andaman",
        },
        {
            id: 4,
            img: hotel,
            name: "ITC Grand",
            price: "10,000",
            place: "Havelock, Andaman",
        }
    ];


    const carData = [
        {
            id: 1,
            title: "Port Blair",
            img: car,
            price: "7,000",
            rating: 4.5
        },
        {
            id: 2,
            title: "South Andaman Tour",
            img: car,
            price: "4,000",
            rating: 4.5
        },
        {
            id: 3,
            title: "Andaman Tour",
            img: car,
            price: "5,000",
            rating: 4.5
        },
        {
            id: 4,
            title: "Swaraj Dweep",
            img: car,
            price: "2,500",
            rating: 5
        },
        {
            id: 5,
            title: "Shaheed Dweep",
            img: car,
            price: "8,000",
            rating: 5
        }
    ];



    const services = [
        {
            id: 1,
            img: water,
            title: "Water Sports",
            subtitle: "Explore the world best scuba diving",
        },
        {
            id: 2,
            img: hotelbook,
            title: "Hotel Booking",
            subtitle: "Book the best hotel",
        },
        {
            id: 3,
            img: ferryboat,
            title: "Ferry Ride Booking",
            subtitle: "A peaceful journey across the waters",
        },
        {
            id: 4,
            img: carrental,
            title: "Car Rental",
            subtitle: "Roam around Andaman",
        },
    ];


    const destinationData = [
        {
            id: 1,
            img: destinationimg1,
            title: "Mount Harriet Day-Trip",
        },
        {
            id: 2,
            img: destinationimg2,
            title: "Long-Island",
        },
        {
            id: 3,
            img: destinationimg3,
            title: "Ross And Smith islands By Boat On Shearing-Basic",
        },
        {
            id: 4,
            img: destinationimg4,
            title: "Neil Island-Bharatpur Beach, Natural Bridge Laxmanpur Beach",
        },
        {
            id: 5,
            img: destinationimg5,
            title: "Neil Island-Bharatpur Beach Lakshmanpur Beach",
        }
    ];


    const testimonialData = [
        {
            id: 1,
            img: testimonialImg,
            name: "Shalini",
            place: "Vadodara",
            text: "The representative were very welcoming, accommodating of our requests, punctual and very helpful. From day 1, we had no worried about schedule changes, late itineraries because Ajay, our coordinator changed everything so we could get what we wanted."
        },
        {
            id: 2,
            img: testimonialImg,
            name: "Lima",
            place: "Mysore",
            text: "The representative were very welcoming, accommodating of our requests, punctual and very helpful. From day 1, we had no worried about schedule changes, late itineraries because Ajay, our coordinator changed everything so we could get what we wanted."
        },
        {
            id: 3,
            img: testimonialImg,
            name: "John Smith",
            place: "Chennai",
            text: "The representative were very welcoming, accommodating of our requests, punctual and very helpful. From day 1, we had no worried about schedule changes, late itineraries because Ajay, our coordinator changed everything so we could get what we wanted."
        },
        {
            id: 4,
            img: testimonialImg,
            name: "Deepika",
            place: "Mumbai",
            text: "The representative were very welcoming, accommodating of our requests, punctual and very helpful. From day 1, we had no worried about schedule changes, late itineraries because Ajay, our coordinator changed everything so we could get what we wanted."
        }
    ];


    const blogData = [
        {
            id: 1,
            img: blogImg1,
            date: "25 Feb 2024",
            title: "Ultimate Guide to Plan Your Dream Vacation"
        },
        {
            id: 2,
            img: blogImg2,
            date: "25 Feb 2024",
            title: "Ultimate Guide to Plan Your Dream Vacation"
        },
        {
            id: 3,
            img: blogImg3,
            date: "25 Feb 2024",
            title: "Ultimate Guide to Plan Your Dream Vacation"
        },
        {
            id: 4,
            img: blogImg3,
            date: "25 Feb 2024",
            title: "Ultimate Guide to Plan Your Dream Vacation"
        }
    ];


    const responsivecar = {
        superLargeDesktop: { breakpoint: { max: 4000, min: 1400 }, items: 5 },
        desktop: { breakpoint: { max: 1400, min: 1100 }, items: 5 },
        laptop: { breakpoint: { max: 1100, min: 900 }, items: 3 },
        tablet: { breakpoint: { max: 900, min: 600 }, items: 2 },
        mobile: { breakpoint: { max: 600, min: 0 }, items: 1 }
    };

    const responsive = {
        desktop: { breakpoint: { max: 3000, min: 1200 }, items: 4, slidesToSlide: 1 },
        laptop: { breakpoint: { max: 1200, min: 992 }, items: 3, slidesToSlide: 1 },
        tablet: { breakpoint: { max: 992, min: 576 }, items: 2, slidesToSlide: 1 },
        mobile: { breakpoint: { max: 576, min: 0 }, items: 1, slidesToSlide: 1 },
    };

    const responsivedestination = {
        superLargeDesktop: { breakpoint: { max: 4000, min: 1400 }, items: 5 },
        desktop: { breakpoint: { max: 1400, min: 1100 }, items: 5 },
        laptop: { breakpoint: { max: 1100, min: 900 }, items: 3 },
        tablet: { breakpoint: { max: 900, min: 600 }, items: 2 },
        mobile: { breakpoint: { max: 600, min: 0 }, items: 1 }
    };

    const responsivetestimonial = {
        superLargeDesktop: { breakpoint: { max: 4000, min: 1400 }, items: 4 },
        desktop: { breakpoint: { max: 1400, min: 1100 }, items: 4 },
        laptop: { breakpoint: { max: 1100, min: 900 }, items: 4 },
        tablet: { breakpoint: { max: 900, min: 600 }, items: 3 },
        mobile: { breakpoint: { max: 600, min: 0 }, items: 1 }
    };

    const responsiveblog = {
        superLargeDesktop: { breakpoint: { max: 2000, min: 1000 }, items: 4 },
        desktop: { breakpoint: { max: 1200, min: 1100 }, items: 4 },
        tablet: { breakpoint: { max: 1000, min: 700 }, items: 4 },
        mobile: { breakpoint: { max: 500, min: 0 }, items: 1 }
    };


    return (
        <>
            {/* Navbar */}
            <Navbarsticky />
            <div className='home-container'></div>
            <div>

                {/* deals */}
                <div className="deals-wrapper w-100">
                    <Container className='d-flex flex-column justify-content-center align-items-center w-100'>
                        <h3 className='my-4 mx-4'>Top Deals</h3>
                        <Row className='w-100'>
                            {dealsData.map((item) => (
                                <Col key={item.id} lg={3} md={6} sm={12} className="mb-4">
                                    <Card className="deal-card">
                                        <div className="img-wrapper">
                                            <img src={item.img} className="card-img-top" alt="" />
                                            <span className="discount-badge">10% Off</span>
                                        </div>

                                        <Card.Body>
                                            <div className="location-text">
                                                <i className="bi bi-geo-alt"></i> {item.location}
                                            </div>

                                            <Card.Title className="deal-title">{item.title}</Card.Title>

                                            <div className="deal-price">
                                                ₹ {item.price}
                                                <span>/person</span>
                                                <div className="rating">
                                                    ⭐⭐⭐⭐⭐
                                                </div>
                                            </div>

                                            <Button className="explore-btn">
                                                Explore <i className="bi bi-arrow-right"></i>
                                            </Button>
                                        </Card.Body>
                                    </Card>
                                </Col>
                            ))}
                        </Row>

                        <div className="text-center mt-4">
                            <button className="explore-more-btn">
                                Explore More Deals <i className="bi bi-arrow-right"></i>
                            </button>
                        </div>
                    </Container>
                </div>

                <div className='d-flex justify-content-center align-items-center'><h1 style={{ marginTop: "1rem", marginBottom: "3rem" }}>Top Andaman Tour Packages</h1></div>

                {/* Hotel */}

                <div className="top-hotel-section">
                    <Container>
                        <h2 className="hotel-heading">Discover The Top Hotel</h2>

                        <Carousel
                            responsive={responsive}
                            infinite={true}
                            autoPlay={true}
                            autoPlaySpeed={2300}
                            arrows={false}
                            showDots={false}
                            pauseOnHover={false}
                            draggable={true}
                            swipeable={true}
                            renderDotsOutside={true}
                            className="hotel-carousel"
                        >
                            {hotelData.map((item) => (
                                <div className="hotel-card" key={item.id}>
                                    <div className="hotel-img-box">
                                        <img src={item.img} alt="" className="hotel-img" />

                                        <span className="hotel-tag">
                                            <i className="bi bi-geo-alt"></i> {item.name}
                                        </span>
                                    </div>

                                    <div className="hotel-info">
                                        <p className="hotel-price">₹ {item.price} onwards</p>
                                        <p className="hotel-place">{item.place}</p>
                                    </div>
                                </div>
                            ))}
                        </Carousel>
                    </Container>
                </div>


                {/* car */}

                <div className="car-package-section">
                    <Container>
                        <h2 className="section-heading">Car Rental Packages</h2>

                        <Carousel
                            responsive={responsivecar}
                            infinite={true}
                            autoPlay={true}
                            autoPlaySpeed={2600}
                            arrows={false}
                            showDots={false}
                            swipeable={true}
                            draggable={true}
                            pauseOnHover={false}
                            renderDotsOutside={true}
                            className="car-carousel"
                        >
                            {carData.map((item) => (
                                <div className="car-card" key={item.id}>
                                    <img src={item.img} className="car-img" />

                                    <h4 className="car-title">{item.title}</h4>

                                    <div className="price-row">
                                        <p className="car-price">₹{item.price}</p>

                                        <div className="star-group">
                                            {"★★★★★".slice(0, Math.round(item.rating))}
                                            <span className="star-fade">
                                                {"★★★★★".slice(Math.round(item.rating))}
                                            </span>
                                        </div>
                                    </div>

                                    <button className="explore-btn">
                                        Explore <i className="bi bi-arrow-right"></i>
                                    </button>
                                </div>
                            ))}
                        </Carousel>
                    </Container>
                </div>


                {/* service provider */}

                <div className="service-section">

                    <h2 className="service-heading">Services We Provide</h2>

                    <div className="service-grid">
                        {services.map((item) => (
                            <div className="service-card" key={item.id}>
                                <img src={item.img} className="service-img" />

                                <div className="service-info">
                                    <h5 className="service-title">{item.title}</h5>
                                    <p className="service-subtitle">{item.subtitle}</p>
                                </div>
                            </div>
                        ))}
                    </div>

                </div>


                {/* destination */}

                <div className="popular-dest-section" style={{ marginTop: "5rem", marginBottom: "5rem" }}>
                    <Container>
                        <h2 className="popular-heading">Explore Popular Destinations</h2>
                        <Carousel
                            responsive={responsivedestination}
                            infinite={true}
                            autoPlay={true}
                            autoPlaySpeed={2300}
                            arrows={false}
                            showDots={false}
                            swipeable={true}
                            draggable={true}
                            pauseOnHover={false}
                            renderDotsOutside={true}
                            rtl={true}
                            className="popular-carousel"
                        >
                            {destinationData.map((item) => (
                                <div className="popular-card" key={item.id}>
                                    <img src={item.img} className="popular-img" />

                                    <h4 className="popular-title">{item.title}</h4>
                                </div>
                            ))}
                        </Carousel>
                    </Container>
                </div>

                {/* testimonial */}

                <div className="testimonial-section">
                    <Container>
                        <h2 className="testimonial-heading">What People Say</h2>

                        <Carousel
                            responsive={responsivetestimonial}
                            infinite={true}
                            autoPlay={true}
                            autoPlaySpeed={2600}
                            arrows={false}
                            showDots={false}
                            draggable={true}
                            swipeable={true}
                            pauseOnHover={false}
                            renderDotsOutside={true}
                            className="testimonial-carousel"
                        >
                            {testimonialData.map((item) => (
                                <div className="testimonial-card" key={item.id}>

                                    <div className="testimonial-header">

                                        <img src={item.img} className="avatar-img" />

                                        <div className="center-info">
                                            <h4 className="t-name">{item.name}</h4>
                                            <p className="t-place">{item.place}</p>
                                        </div>

                                        <div className="quote-icon">❝</div>

                                    </div>


                                    <p className="t-text">{item.text}</p>
                                </div>
                            ))}
                        </Carousel>
                    </Container>
                </div>

                {/* blog */}

                <div className="blog-section">
                    <Container>
                        <h2 className="blog-heading">Latest Blog</h2>

                        <Carousel
                            responsive={responsiveblog}
                            infinite={true}
                            autoPlay={true}
                            autoPlaySpeed={2600}
                            arrows={false}
                            showDots={false}
                            renderDotsOutside={true}
                            pauseOnHover={false}
                            className="blog-carousel"
                        >
                            {blogData.map((item) => (
                                <div className="blog-card" key={item.id}>

                                    <div className="blog-img-box">
                                        <img src={item.img} className="blog-img" />

                                        <div className="date-badge">
                                            <i className="bi bi-calendar"></i> {item.date}
                                        </div>
                                    </div>

                                    <div className="blog-body">
                                        <h4 className="blog-title">{item.title}</h4>

                                        <p className="read-more">
                                            Read More <i className="bi bi-arrow-right-circle-fill"></i>
                                        </p>
                                    </div>
                                </div>
                            ))}
                        </Carousel>
                    </Container>
                </div>
            </div>
            {/* Footer */}
            <Footer />
        </>
    )
}
